import React, { FC, useEffect } from "react";
import { Helmet } from "react-helmet";
import { Block } from "kanopi-components/Block";
import { useUser } from "kw/auth/useUser";

export const SettingsPage: FC = () => {
  const user = useUser();

  return (
    <>
      <Helmet>
        <title>Settings - {user?.organization?.name}</title>
      </Helmet>
      <Block
        display="flex"
        flexDirection="column"
        alignContent="center"
        alignItems="center"
      >
        <h1>Settings</h1>
      </Block>
    </>
  );
};
